module.exports = __webpack_public_path__ + "static/media/pic2.1449ae4d.jpg";